<template>
    <div class="flex justify-center py-2 bg-gradient-to-t from-gray-200 to-transparent">
        <span
            class="cursor-pointer rounded-full bg-blue-100 px-3 py-1 text-sm font-semibold text-blue-600 shadow-sm hover:bg-blue-200"
            data-testid="new-messages-indicator"
            @click="$emit('click')"
        >
            {{
                tc('smsCommunication.messagesList.newMessages', messageCount, {
                    count: messageCount,
                })
            }}
            ↓
        </span>
    </div>
</template>

<script setup lang="ts">
    import { useI18n } from '@/hooks/useI18n.ts';

    interface Props {
        messageCount: number;
    }

    defineProps<Props>();

    defineEmits<(e: 'click') => void>();

    const { tc } = useI18n();
</script>
